var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('router-view',{attrs:{"exact":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }